module.exports = __webpack_public_path__ + "img/smesny@2x.9736f6a4.webp";